import { useRef, useState } from "react";
import { ChevronDownIcon } from "../../icons";
import useClickOutside from "./useClickOutside";

const AssetCheckbox = ({ checked }) => (
  <span
    className={`flex size-5 shrink-0 items-center justify-center rounded-[4px] ${
      checked ? "bg-[#4ab933]" : "border border-divider bg-background-surface"
    }`}
    aria-hidden
  >
    {checked && (
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M2.5 7L5.5 10L11.5 4"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </span>
);

const AssetFilter = ({ cryptoAccounts, selectedAssets, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useClickOutside(containerRef, isOpen, () => setIsOpen(false));

  const toggleAsset = (id) => {
    if (selectedAssets.includes(id)) {
      onChange(selectedAssets.filter((item) => item !== id));
      return;
    }
    onChange([...selectedAssets, id]);
  };

  return (
    <div ref={containerRef} className="relative shrink-0">
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        className="flex h-9 items-center justify-center gap-[7px] rounded-[6px] border border-solid border-divider bg-background-surface px-2 custom-transition hover:bg-option-hover"
      >
        <span className="whitespace-nowrap text-sm font-medium leading-[19.5px] text-text-primary">
          Asset
        </span>
        <ChevronDownIcon
          size={16}
          className={`text-text-secondary custom-transition ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="absolute border border-solid border-divider left-0 top-[calc(100%+4px)] z-50 w-[138px] overflow-hidden rounded-[8px] bg-background-surface pt-2 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.16)]">
          {cryptoAccounts && cryptoAccounts.map((asset) => {
            const isChecked = selectedAssets.includes(asset.id);

            return (
              <button
                key={asset.id}
                type="button"
                onClick={() => toggleAsset(asset.id)}
                className="flex w-full items-center gap-2 px-2 py-2.5 text-left custom-transition hover:bg-[rgba(74,185,50,0.04)]"
              >
                <AssetCheckbox checked={isChecked} />
                <div className="flex min-w-0 items-center gap-1">
                  <div className="flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full">
                    <img
                      src={asset.logo}
                      alt=""
                      className="size-6 rounded-full object-cover"
                    />
                  </div>
                  <span className="whitespace-nowrap text-xs font-medium leading-[19.5px] text-text-primary">
                    {asset.currency_code}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AssetFilter;
